module.exports = __webpack_public_path__ + "img/twitter.1d5efd7d.svg";